import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminProductCharacteristicRequest } from './admin-product-characteristic.request';
import { AdminProductFileRequest } from './admin-product-file.request';
import { AdminDictionaryProductAttributeRequest } from '@web/shared/module/dictionary';
import { AdminProductStatus } from '../../enums/admin-product-status';

@jsonObject
export class AdminProductCreateRequest {
  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly password?: Nillable<string>;

  @jsonMember(String)
  public readonly price?: Nillable<string>;

  @jsonMember(String)
  public readonly cosmeticBrandId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly featuredFileId?: Nillable<Guid>;

  @jsonMember(String)
  public readonly status!: AdminProductStatus;

  @jsonMember(Boolean)
  public readonly virtual?: Nillable<boolean>;

  @jsonMember(Number)
  public readonly maxQuantityPerOrder?: Nillable<number>;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  @jsonMember(String)
  public readonly warehouseGoodId?: Nillable<Guid>;

  @jsonArrayMember(AdminDictionaryProductAttributeRequest)
  public readonly attributes?: Nillable<
    AdminDictionaryProductAttributeRequest[]
  >;

  @jsonArrayMember(AdminProductCharacteristicRequest)
  public readonly characteristics?: Nillable<
    AdminProductCharacteristicRequest[]
  >;

  @jsonArrayMember(AdminProductFileRequest)
  public readonly files?: Nillable<AdminProductFileRequest[]>;

  public constructor(
    private readonly data: {
      attributes?: Nillable<AdminDictionaryProductAttributeRequest[]>;
      characteristics?: Nillable<AdminProductCharacteristicRequest[]>;
      cosmeticBrandId?: Nillable<Guid>;
      featuredFileId?: Nillable<Guid>;
      files?: Nillable<AdminProductFileRequest[]>;
      name: string;
      password?: Nillable<string>;
      price?: Nillable<string>;
      status: AdminProductStatus;
      virtual?: Nillable<boolean>;
      maxQuantityPerOrder?: Nillable<number>;
      availableQuantity?: Nillable<number>;
      warehouseGoodId?: Nillable<Guid>;
    },
  ) {
    this.attributes = this.data.attributes;
    this.characteristics = this.data.characteristics;
    this.cosmeticBrandId = this.data.cosmeticBrandId;
    this.featuredFileId = this.data.featuredFileId;
    this.files = this.data.files;
    this.name = this.data.name;
    this.password = this.data.password;
    this.price = this.data.price;
    this.status = this.data.status;
    this.virtual = this.data.virtual;
    this.maxQuantityPerOrder = this.data.maxQuantityPerOrder;
    this.availableQuantity = this.data.availableQuantity;
    this.warehouseGoodId = this.data.warehouseGoodId;
  }
}
